/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './validate_and_standardize_address';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "AddressService": {
                    "methods": {
                      "ValidateAndStandardizeAddress": {
                        "requestType": ".squareup.sfs.external.service.ValidateAndStandardizeAddressRequest",
                        "responseType": ".squareup.sfs.external.service.ValidateAndStandardizeAddressResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.AddressService) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc External RPCs for interacting with Square address.
 * --
 *
 * SOURCE AddressService @ squareup/sfs/external/services/address/address_service.proto at 11:1
 */
export const AddressService = $root.lookupService('squareup.sfs.external.service.AddressService');